import { useContext } from "react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { userLikeRecipeApi } from "../services/recipe.api"
import { toast } from "sonner"
import AuthContext from "../../../app/Context/AuthContext"

export const useLikeRecipe=()=>{
  const {handleError}=useContext(AuthContext)
    const queryClient = useQueryClient()
    return useMutation({
        onMutate:async(recipe)=>{
          await queryClient.cancelQueries({queryKey:["Me"]})
          const previousUser = queryClient.getQueryData(["Me"])
          queryClient.setQueryData(["Me"],(oldData)=>{
            if(!oldData) return oldData
            const alreadyLiked=oldData.likedRecipes.includes(recipe._id)
            return {
                ...oldData,
                likedRecipes:alreadyLiked?oldData.likedRecipes.filter((id)=>id !==recipe._id):[...oldData.likedRecipes,recipe._id]
            }
          })
          queryClient.setQueriesData({queryKey:["user-likedRecipes"]},(oldData)=>{
            if(!oldData) return oldData
            const alreadyLiked=oldData.recipes.some((item)=>item._id===recipe._id)
            return {
      ...oldData,
      recipes: alreadyLiked
        ? oldData.recipes.filter(
            (item) => item._id !== recipe._id
          )
        : [...oldData.recipes, recipe]
    }
          })
          return {previousUser}
        },
        mutationFn:async(recipe)=>{
    const response=await userLikeRecipeApi({likedRecipeId:recipe._id})
     return response.data
        },
         retry:false,
         onSuccess:(data)=>{
     toast.success(data.message)
        },
        onSettled:()=>{
queryClient.invalidateQueries({
   queryKey:["Me"],
   })
queryClient.invalidateQueries({
   queryKey:["user-likedRecipes"]
   })
        },
     onError:(error,data,context)=>{
      handleError(error)
         queryClient.setQueryData(
    ["Me"],
    context.previousUser
  )
    }

    })
}
